import React, { useRef } from "react"

import classNames from "classnames"

import { HEADER_HEIGHT_VARIABLE_NAME } from "shared/constants/app-constants"
import { PopoverContext } from "shared/context/PopoverContext"
import { useElementHeight } from "shared/lib/css/useElementHeight"
import { useIsProductConfigurationPage } from "shared/lib/useIsProductConfigurationPage"
import { useMergedRefs } from "shared/lib/useMergedRefs"
import { Chip, ChipVariant } from "shared/ui/chip/Chip"

import { GlobalSearchButton } from "features/global-search/ui/global-search/ui/GlobalSearchButton"
import { ActiveProjectSelect } from "widgets/header/active-project-select/ActiveProjectSelect"

import { HeaderModel } from "../Header"
import "../styles/_header.scss"
import { HeaderLogo } from "./HeaderLogo"
import { HeaderMenuButton } from "./HeaderMenuButton"

export const HeaderView = React.memo(
  React.forwardRef(
    (
      {
        projectContextSelectModel,
        isAuthenticated,
        logoLinkProps,
        portalStage,
        menuButtonProps,
        openGlobalSearch
      }: HeaderModel,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => {
      const internalRef = useRef<HTMLDivElement>(null)
      const mergedRefs = useMergedRefs(ref, internalRef)
      const isProductConfigurationPage = useIsProductConfigurationPage()

      useElementHeight(internalRef, {
        variableName: HEADER_HEIGHT_VARIABLE_NAME
      })
      if (isProductConfigurationPage) {
        return null
      }

      return (
        <PopoverContext.Provider value="header-popover-root">
          <header
            id="header"
            className={classNames("header schako-header fixed-size", {
              "logged-in": isAuthenticated
            })}
            data-testid="header"
            ref={mergedRefs}
          >
            <div id="header-popover-root" style={{ position: "absolute" }} />
            <div className="header__logo-and-menu">
              <HeaderMenuButton {...menuButtonProps} />
              <HeaderLogo {...logoLinkProps} />
              <Chip className="header__stage" variant={ChipVariant.INFO}>
                {portalStage}
              </Chip>
            </div>

            <div className="header__search">
              <GlobalSearchButton onClick={openGlobalSearch} />
            </div>

            {isAuthenticated ? (
              <div className="header__projects">
                <ActiveProjectSelect {...projectContextSelectModel} />
              </div>
            ) : null}
            <div className="header__search-icon">
              <GlobalSearchButton isIconOnly onClick={openGlobalSearch} />
            </div>
          </header>
        </PopoverContext.Provider>
      )
    }
  )
)
